import { type Board, type Clip } from '@air/api/types';

import { type DraggingItems, DragType, isBoardDragType } from '~/components/Shared/Drag/dragTypes';

export const assetOrFileDragTypes = [DragType.asset, DragType.file] as const;

export type AssetOrFileDragType = (typeof assetOrFileDragTypes)[number];

export const isAssetOrFileDragType = (type: DragType): type is AssetOrFileDragType =>
  type === DragType.asset || type === DragType.file;

export function hasClipFirstItem(items: DraggingItems<Board | Clip>): items is DraggingItems<Clip> {
  return isAssetOrFileDragType(items.type);
}

export function hasBoardFirstItem(items: DraggingItems<Board | Clip>): items is DraggingItems<Board> {
  return isBoardDragType(items.type);
}
